"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const layout_1 = require("../layout");
exports.withCategoryNotFoundHandler = (Component) => class WithCategoryNotFoundHandler extends React.Component {
    render() {
        if (this.props.data.category) {
            return React.createElement(Component, Object.assign({}, this.props));
        }
        else {
            return React.createElement(layout_1.PageLayout, { title: "Category Not Found" });
        }
    }
};
